up.compiler('.js-email_verification', function (input) {
  const invalidEmailError = input.dataset.error
  const errorSelector = document.querySelector(input.dataset.errorSelector)
  const label = document.querySelector(`label[for=${input.id}]`)

  const setError = message => {
    errorSelector.setAttribute('aria-live', 'polite')
    errorSelector.setAttribute('role', 'alert')
    input.setAttribute('aria-invalid', 'true')
    errorSelector.innerHTML = message
    label.classList.add('label--error')
  }

  const hideError = () => {
    errorSelector.innerHTML = ''
    input.setAttribute('aria-invalid', 'false')
    label.classList.remove('label--error')
    const wrapperWithErrorClass = label.closest('.error')
    if (wrapperWithErrorClass) {
      wrapperWithErrorClass.classList.remove('error')
    }
  }

  up.on(input, 'focus', function () {
    hideError()
  })

  up.on(input, 'blur', function (event) {
    if (event.target.value && !event.target.checkValidity()) {
      setError(invalidEmailError)
    }
  })
})
